import { IUser } from "../../control-core/models/se/user.model";
import { DireccioneModel, IDireccion } from "./general/cliente.model";

export interface IUserC extends IUser {
  lastname: string;
  idbox: string;
  telefono: string;
  identificacion: string;
  direcciones ?: Array<IDireccion>;
  dir_envios ?: Array<IDireccion>;
  escorporativo ?: boolean;
  cambiar_password ?: boolean;
  acepto_term_cond : string;
  created_at : string;
  fecha_utila_guia : string;
  nrogui_utila_guia : string;
  numguias : number;
}

export class UserCModel implements IUserC {
  lastname: string = "";
  idbox: string = "";
  telefono: string = "";
  identificacion: string = "";
  id: string = "";
  name: string = "";
  email: string = "";
  acepto_term_cond: string = "";
  direcciones: Array<DireccioneModel> = [];
  dir_envios: Array<DireccioneModel> = [];
  escorporativo:boolean = false;
  cambiar_password: boolean = false;
  created_at : string = "";
  fecha_utila_guia : string = "";
  nrogui_utila_guia : string = "";
  numguias : number;
}


// WEBPACK FOOTER //
// ./src/app/control-app/models/user.model.ts